export default "__VITE_ASSET__9c28f94e__"